module.exports = __webpack_public_path__ + "img/student_16.bd24fc4a.png";